module.exports = __webpack_public_path__ + "static/media/sb.7be87f0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sb.png
// module id = 1972
// module chunks = 0